import { getBoxBaseProps } from './box-base-props';
import { getFlexContentProps, getContainerFlexProps, getColFlexProps, getSpacerFlexProps, getAlignColProps, getAlignRowProps, getJustifyRowProps, getJustifyColProps } from './style';
export function getContentProps(props, ref) {
    props.elementMode = 'container';
    var baseProps = getBoxBaseProps(props, ref, [getFlexContentProps, getJustifyRowProps, getAlignRowProps, getContainerFlexProps]);
    return baseProps;
}
export function getRowProps(props, ref) {
    var baseProps = getBoxBaseProps(props, ref, [getFlexContentProps, getJustifyRowProps, getAlignRowProps, getContainerFlexProps]);
    return baseProps;
}
export function getColProps(props, ref) {
    var baseProps = getBoxBaseProps(props, ref, [getFlexContentProps, getAlignColProps, getJustifyColProps, getColFlexProps]);
    return baseProps;
}
export function getSpacerProps(props, ref) {
    var baseProps = getBoxBaseProps(props, ref, [getFlexContentProps, getAlignColProps, getJustifyColProps, getSpacerFlexProps]);
    return baseProps;
}
